function Footer() {
    return (
        <footer>
            <p>Double Tap est un serveur privé Dofus innovant aux multiples facettes.</p>
            <p>Développé par <a href="https://github.com/BlackPearlsDev" target={'_blank'} rel="noreferrer">Black Pearl</a></p>
        </footer>
    )
}

export default Footer;